import { Children, cloneElement, useCallback, useEffect, useRef } from 'react'
import styled from 'styled-components'
import isEqual from 'lodash/isEqual'
import noop from 'lodash/noop'

const Wrapper = styled.div`
  display: flex;
  flex-direction: ${({ vertical }) => (!vertical ? 'row' : 'column')};
  border-radius: 10px;

  > :not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  > :not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;

    ${props =>
      props.vertical &&
      `
    border-bottom: none;
    `}
    ${props =>
      !props.vertical &&
      `
    padding-right: 1px;
    border-right: none;
    `}
  }

  ${props =>
    props.vertical &&
    `
    > div {
      border-left: none;
      border-right: none;
    }
    > :first-child {
      border-top: none;
    }
    > :last-child {
      border-bottom: none;
    }
  `}

  ${({ customStyle }) => customStyle};

  ${props =>
    props.disabled &&
    `
    cursor: default;
    opacity: 0.5;
    pointer-events: none;
  `};

  ${props =>
    props.noBorderRadius &&
    `
    border-radius: 0;
    > div {
      border-radius: 0 !important;
    }
  `};
`

const OptionList = ({
  children,
  onChange,
  value,
  optionCustomStyle = [],
  clickOutsideCallback = noop,
  ...rest
}) => {
  const ref = useRef()
  const handleClick = useCallback(
    e => {
      if (!ref?.current || ref?.current.contains(e.target)) {
        return
      }

      clickOutsideCallback(e)
    },
    [clickOutsideCallback]
  )
  useEffect(() => {
    document.addEventListener('mousedown', handleClick, false)
    return () => document.removeEventListener('mousedown', handleClick, false)
  }, [handleClick])
  return (
    <div ref={ref}>
      <Wrapper {...rest}>
        {Children.map(children, child => {
          // undefined is sometimes cast into null from react props
          // and null and undefined are not equal
          const removeNull = val => (val !== null ? val : undefined)
          const selected = isEqual(
            removeNull(child.props.value),
            removeNull(value)
          )
          return cloneElement(child, {
            isSelected: selected,
            customStyle: optionCustomStyle,
            horizontal: rest.horizontal,
            onClick: onChange
          })
        })}
      </Wrapper>
    </div>
  )
}

export default OptionList
